import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages';
import FrutoSeco from './pages/frutoseco';
import About from './pages/about';
import Container from './components/Container';



function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Container><Home/></Container>}  />
        <Route path='/frutoseco' element={<Container><FrutoSeco/></Container>}  />
        <Route path='/about' element={<Container><About/></Container>}  />
      </Routes>
    </Router>
  );
}

export default App;
